import { projectSlice } from '../slices/project.slice';

export const { setProject, setProjectInfo } = projectSlice.actions;
